var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome4Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.869565 1.19921e-07C0.389317 1.19921e-07 0 0.389318 0 0.869565C0 1.34981 0.389317 1.73913 0.869565 1.73913H2.41678C2.54338 1.73913 2.66678 1.77897 2.76948 1.853C2.87219 1.92703 2.949 2.0315 2.98903 2.15161L5.85597 10.7541C5.98329 11.136 5.99948 11.5473 5.90183 11.9378L5.66576 12.8838C5.31937 14.2694 6.39789 15.6522 7.82608 15.6522H18.2609C18.7411 15.6522 19.1304 15.2629 19.1304 14.7826C19.1304 14.3024 18.7411 13.913 18.2609 13.913H7.82608C7.48748 13.913 7.27011 13.6352 7.35224 13.3067L7.53026 12.5957C7.56043 12.4752 7.62999 12.3683 7.7279 12.2918C7.82581 12.2154 7.94645 12.1739 8.07065 12.1739H17.3913C17.7657 12.1741 18.0982 11.9346 18.2167 11.5795L20.535 4.62296C20.7228 4.05967 20.3033 3.47799 19.7096 3.47826H5.69972C5.57312 3.47826 5.44972 3.43843 5.34701 3.3644C5.2443 3.29037 5.16749 3.1859 5.12745 3.06579L4.30367 0.594429C4.18517 0.239265 3.85267 -0.000195628 3.47826 1.19921e-07H0.869565Z",
    fill: "#161E40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95652 16.5217C5.99602 16.5217 5.21739 17.3004 5.21739 18.2609C5.21739 19.2214 5.99602 20 6.95652 20C7.91701 20 8.69565 19.2214 8.69565 18.2609C8.69565 17.3004 7.91701 16.5217 6.95652 16.5217Z",
    fill: "#161E40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3913 16.5217C16.4308 16.5217 15.6522 17.3004 15.6522 18.2609C15.6522 19.2214 16.4308 20 17.3913 20C18.3518 20 19.1304 19.2214 19.1304 18.2609C19.1304 17.3004 18.3518 16.5217 17.3913 16.5217Z",
    fill: "#161E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome4Svg);
export default __webpack_public_path__ + "static/media/home4svg.4075d48ab0fccbcb73b84dd9b17b0ef8.svg";
export { ForwardRef as ReactComponent };